import React, { FC } from 'react';
import styled from 'src/theme';
import { Routes } from 'src/utils/routes';
import { useHistory } from 'react-router-dom';

import { Row, Col, Space } from 'antd';
import { Button } from 'src/components/UI';
import { orionLogoJPG } from 'src/assets/images';

export const MainComponent: FC = () => {
  const history = useHistory();

  const handleClickFence = () => {
    history.push(Routes.fence);
  };

  const handleClickRoof = () => {
    history.push(Routes.roof);
  };

  return (
    <Row gutter={[8, 16]}>
      <Col span={24}>
        <LogoStyled src={orionLogoJPG} />
      </Col>
      <Col xs={24} sm={12}>
        <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
          <Button onClick={handleClickFence}>
            КАЛЬКУЛЯТОР ЗАБОРА
          </Button>
        </Space>
      </Col>
      <Col xs={24} sm={12}>
        <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
          <Button onClick={handleClickRoof}>
            КАЛЬКУЛЯТОР КРОВЛИ
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

const LogoStyled = styled.img`
  margin: 8px;
  width: 120px;
  height: auto;
`;
